import React from "react";
import { connect } from "react-redux";
import {
    roleHasPermission,
    mapStateToRolePermissions,
} from "utils/permissions/rolePermissions";

const AccessControlNavItem = ({
    dropdowns,
    hasDropdown,
    baseResources,
    children,
    role,
}) => {
    const renderBasedOnDropDown = () => {
        const dropdownIsAccessible = (dropdown) => {
            if (dropdown?.hide) return false;
            return roleHasPermission(role, dropdown?.baseResources);
        };

        switch (hasDropdown) {
            case true:
                return (
                    <>
                        {dropdowns?.find(dropdownIsAccessible) ? (
                            <>{children}</>
                        ) : (
                            <></>
                        )}
                    </>
                );

            default:
                return (
                    <>{roleHasPermission(role, baseResources) ? children : <></>}</>
                );
        }
    };
    return <>{renderBasedOnDropDown()}</>;
};

export default connect((state) => ({
    ...mapStateToRolePermissions(state),
    role: state?.auth?.user?.role,
}))(AccessControlNavItem);
